import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import classNames from 'classnames';

import { roundDownSmallValue } from '@xanadu/ui-shared/utils/numbers';
import Currency from '../../../containers/Currency';

import styles from './CasinoBonus.module.scss';

const CasinoBonus = ({
  wallet,
  displayName,
  expiryDate,
  termsAndConditions,
  bonusType
}) => {
  const isFreeRound = bonusType === 'freeRound';

  const labelContainerClass = classNames({
    [styles.labelContainer]: true,
    [styles['labelContainer--rollover']]: true
  });
  return (
    <div className={styles.casinoBonusContainer}>
      <div className={styles.labelContainer}>
        {!isFreeRound &&
          (<Fragment>
            <span>{displayName}</span>
            <Currency value={roundDownSmallValue(wallet.amount)} />
          </Fragment>
          )
        }
      </div>
      {!isFreeRound && (
        <Fragment>
          <div className={labelContainerClass}>
            <span>Rollover Target</span>
            <Currency value={roundDownSmallValue(wallet.rolloverTarget)} />
          </div>
          <div className={labelContainerClass}>
            <span>Played Amount</span>
            <Currency value={roundDownSmallValue(wallet.rolloverTotal)} />
          </div>
        </Fragment>
      )}
      {wallet.freeRounds && (
        <div className={styles.labelContainer}>
          <span>Free Spins</span>
          <span className={styles.freeRounds}>{`x${wallet.freeRounds}`}</span>
        </div>
      )}
      <div className={labelContainerClass}>
        <span>Expiry Date</span>
        <span className={styles.freeRounds}>{expiryDate ? format(new Date(expiryDate), 'do MMMM yyyy') : 'N/A'}</span>
      </div>
      {termsAndConditions &&
        <div className={`${styles.labelContainer} ${styles['labelContainer--tyc']}`}>
          <Link
            to={termsAndConditions}
            className={styles.termsAndConditions}
          >
            <span>Terms & Conditions</span>
          </Link>
        </div>
      }
    </div>
  );
};

CasinoBonus.propTypes = {
  wallet: PropTypes.instanceOf(Object).isRequired,
  displayName: PropTypes.string.isRequired,
  expiryDate: PropTypes.string.isRequired,
  termsAndConditions: PropTypes.string.isRequired,
  bonusType: PropTypes.string.isRequired,
};

export default CasinoBonus;
